import { Box } from "@mui/material";

import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import IconTable from "./components/IconTable";

const VIEW_TITLE: ViewNameTranslation = "nav.viewname.settings icon table";

export function IconTablePage() {
  useNavbar({ viewTitle: VIEW_TITLE });

  return (
    <Box sx={{ p: 3, width: "100%", maxWidth: "unset !important" }}>
      <IconTable />
    </Box>
  );
}
